export const CONTACT_LINKS = {
  email: 'mailto:info@egobalance.com.ua',
  privacyPolicy: '/EgoBalance_Privacy_Policy.pdf',
  facebook: 'https://www.facebook.com/egobalance',
  instagram: 'https://www.instagram.com/egobalance/',
  telegram: 'https://t.me/egobalancecomua',
} as const;
